import { useQuery } from '@tanstack/react-query';

import { Api } from '@/api';
import { IItem } from '@/types/feed.types';

export const useItemDetails = (itemId: string) => {
  const {
    data: itemDetails,
    isLoading,
    refetch,
    isError,
    error,
  } = useQuery<IItem>({
    queryKey: ['item', itemId],
    queryFn: () => Api.item.fetchItem({ itemId }),
    enabled: !!itemId,
    retry: 1,
    throwOnError: false,
  });

  return {
    itemDetails,
    isLoading,
    refetch,
    isError,
    error,
  };
};
